// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2QDdT","title":"Images90_title__1I3KM","images":"Images90_images__xxjLv"};